import React, { memo } from "react";
import type { IconProps } from "./_IconProps";

const ArrowBack = ({ color, size }: IconProps) => (
  <svg width={size || "24px"} height={size || "24px"} viewBox="0 0 24 24">
    <g
      id="ic/arrow-back-w"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <polygon id="Shape" points="0 0 24 0 24 24 0 24"></polygon>
      <polygon
        id="Shape"
        fill={color || "#000000"}
        fillRule="nonzero"
        points="16.42 5.41 15 4 7 12 15 20 16.41 18.59 9.83 12"
      ></polygon>
    </g>
  </svg>
);

export default memo(ArrowBack);
